import BaseResource from '@sigmacloud/sigma-client/dist/resources'

// {{url}}/typedexports?type=PR_NACHA_DD&page_size=10&page=1&timestamp__gte=2022-02-25T00:00:0.000000Z
export default class TypedExports extends BaseResource {
  static endpoint = '/typedexports'
  static modelName = 'TypedExports'
}



// WEBPACK FOOTER //
// ./src/resources/TypedExportsResource.js